<script setup>
import { useCurrency } from '@/composables/useCurrency'
import { useI18n } from 'vue-i18n'

defineProps({ loss: { type: Object, required: true } })

const { t } = useI18n()
const { formatMoney, formatDate } = useCurrency()

const categoryLabel = (cat) => t(`losses.categories.${cat}`)
</script>

<template>
  <div class="space-y-2">
    <div class="flex items-start justify-between gap-3">
      <div class="min-w-0 flex-1">
        <div class="text-[color:var(--ink)] font-medium">
          {{ categoryLabel(loss.category) }}
        </div>
        <div class="text-xs text-[color:var(--muted)] tabular-nums mt-0.5">
          {{ formatDate(loss.occurred_on) }}
        </div>
      </div>
      <div class="shrink-0 fw-value tabular-nums text-[color:var(--danger)]">
        −{{ formatMoney(loss.amount_cents) }}
      </div>
    </div>
    <div
      v-if="loss.description"
      class="text-xs text-[color:var(--inkSoft)] line-clamp-2"
    >
      {{ loss.description }}
    </div>
  </div>
</template>
